import { IconButton, type IconButtonProps } from "@mui/material";

interface Props extends IconButtonProps {
  alwaysVisible?: boolean;
}

const FieldItemActionButton = ({ alwaysVisible, onClick, sx = [], ...props }: Props) => (
  <IconButton
    {...props}
    draggable
    onDragStart={(event) => event.preventDefault()}
    onPointerDown={(event) => event.stopPropagation()}
    onClick={(event) => {
      event.stopPropagation();
      onClick?.(event);
    }}
    sx={[
      { width: 30, height: 30, p: 0.5, flexShrink: 0 },
      !alwaysVisible && {
        width: 0,
        p: 0,
        opacity: 0,
        overflow: "hidden",
        pointerEvents: "none",
        transition: "none",
        ".field-item-row:hover &, .field-item-row:has(:focus-visible) &": {
          width: 30,
          p: 0.5,
          opacity: 1,
          overflow: "visible",
          pointerEvents: "auto",
          transition: "opacity 120ms ease-out",
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export default FieldItemActionButton;
